<template>
  <router-view/>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Righteous&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Rubik&display=swap');

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    /* font-family: 'Righteous', sans-serif; */
    font-family: 'Rubik', sans-serif;
}
html,body,section{
    background-color: #000;
    scroll-behavior: smooth;
}


.features .heading h2{
    color: #fff;
    /* background-color: #ff6600; */
    font-size: 200%;
}
.features .row{
    width: 80%;
}
.features .project{
    width: 17rem;
    height: 23rem;
    background-color: #313131;
}
.features .game{
    height: 20rem;
}
.features p{
    color: #fff;
    font-size: 80%;
}
.features .card-title{
    color: #ff6600;
    font-size: 130%;
}

.projects,.features,.about{
  background-color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  text-align: center;
}

@media screen and (max-width: 900px){
  .hero h2{
      font-size: 350%;
  }
  .hero p{
      font-size: 1rem;
      padding-left: 10%;
      padding-right: 10%;
  }
  .features .heading h2{
      font-size: 175%;
  }
  .features .row{
      font-size: 100%;
  }
  .features .project{
      width: 20rem;
  }
  .projects .heading h2{
      font-size: 175%;
  }
  .features .game{
    height: 22rem;
}
  .projects .row{
      width: 100%;
  }
  .projects .category-container{
      width: 8.5rem;
      height: 9.5rem;
  }
  .projects .category{
    width: 8rem;
    height: 9.5rem;
  }
  .projects .category .card-title{
    font-size: 1.2rem;
  }
}
</style>
